<template>
  <v-card>
    <div class="preview-section-header">
      <div class="d-flex justify-space-between align-center py-4 container">
        <div>Preview Section</div>
        <div>
          <v-btn-toggle v-model="previewMode" mandatory dense>
            <v-btn value="desktop">
              <v-icon size="16">mdi-monitor</v-icon>
              <span class="ml-1 d-none d-sm-inline">Desktop</span>
            </v-btn>
            <v-btn value="mobile">
              <v-icon size="16">mdi-cellphone</v-icon>
              <span class="ml-1 d-none d-sm-inline">Mobile</span>
            </v-btn>
          </v-btn-toggle>
          <v-btn class="ml-4" color="primary" @click="handleClose">Close</v-btn>
        </div>
      </div>
    </div>
    <div :class="previewMode === 'mobile' ? 'mobile-preview' : 'desktop-preview'">
      <div class="container-size preview-wrapper" ref="sectionContainer">
        <section class="sp-layout container">
          <div id="preview-product" class="sp-gallery">
            <img v-if="imageSrc" :src="imageHelpers.url(imageSrc, { width: 1920, height: 1920 })" alt="Product image" />
            <div v-else>No images</div>
          </div>
          <div class="sp-info-col">
            <div class="sp-info-wrapper">
              <div>
                <div class="sp-reviewer-text">
                  <p>
                    <strong style="color: rgb(69, 69, 69); font-size: 16px">Christine K.&nbsp;</strong
                    ><span style="color: rgb(69, 69, 69); font-size: 16px">and&nbsp;</span
                    ><strong style="color: rgb(69, 69, 69); font-size: 16px">565,000+ others</strong
                    ><span style="color: rgb(69, 69, 69); font-size: 16px">&nbsp;love our shoes</span>
                  </p>
                </div>
              </div>
              <h1 class="sp-title">{{ title || 'Product name' }}</h1>
              <div class="sp-rating">
                <ul class="sp-stars">
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="sp-star-icon"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                        clip-rule="evenodd"
                        fill="#f0b100"
                      ></path>
                    </svg>
                  </li>
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="sp-star-icon"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                        clip-rule="evenodd"
                        fill="#f0b100"
                      ></path>
                    </svg>
                  </li>
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="sp-star-icon"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                        clip-rule="evenodd"
                        fill="#f0b100"
                      ></path>
                    </svg>
                  </li>
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="sp-star-icon"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                        clip-rule="evenodd"
                        fill="#f0b100"
                      ></path>
                    </svg>
                  </li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="sp-star-icon">
                      <defs>
                        <linearGradient id="starGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="50%" style="stop-color: rgb(240, 177, 0); stop-opacity: 1"></stop>
                          <stop offset="50%" style="stop-color: rgb(211, 211, 211); stop-opacity: 1"></stop>
                        </linearGradient>
                      </defs>
                      <path
                        fill-rule="evenodd"
                        d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                        clip-rule="evenodd"
                        fill="url(#starGradient)"
                      ></path>
                    </svg>
                  </li>
                </ul>
                <p class="sp-rating-count">14,846+ Happy Customers</p>
              </div>

              <!-- Hurry Box: custom or default -->
              <div v-if="hurryBoxHtml" v-html="hurryBoxHtml"></div>
              <div v-else>
                <div class="sp-description">
                  <p>
                    <span style="font-size: 16px; color: rgb(69, 69, 69)">Relieves pressure on feet and joints</span>
                  </p>
                  <p><span style="font-size: 16px; color: rgb(69, 69, 69)">Developed with podiatrist</span></p>
                  <p><span style="font-size: 16px; color: rgb(69, 69, 69)">Free shipping</span></p>
                </div>
              </div>

              <!-- Add to cart (always shown) -->
              <div id="add-to-cart" class="sp-atc">
                <div class="sp-divider">
                  <div class="sp-divider-line"></div>
                  <p class="sp-divider-text">Buy More, Save More!</p>
                  <div class="sp-divider-line"></div>
                </div>
                <div class="sp-btn-group">
                  <button
                    aria-label="Add to cart"
                    title="Add to cart"
                    class="sp-btn-cart"
                    style="--color-cart-label: #ffffff; --color-cart-background: #1f6d5c"
                  >
                    Add to cart
                  </button>
                  <button
                    id="buy-now"
                    aria-label="Buy now"
                    title="Buy now"
                    class="sp-btn-buynow"
                    style="--color-bynow-label: #ffffff; --color-bynow-background: #000"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                      class="sp-btn-icon"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                      ></path></svg
                    >Buy now
                  </button>
                </div>
              </div>
              <div class="sp-paypal">
                <div class="sp-paypal-inner">
                  <img
                    :src="
                      replaceImageUrl(
                        'https://cdn.skyfastimg.com/images/2026/03/20/image-69bd21271fab335b8d5e43c1.png?w=50&h=50&q=80',
                      )
                    "
                    alt="Paypal"
                  />
                </div>
              </div>
              <!-- Order Policy: custom or default -->
              <div v-if="orderPolicyHtml" v-html="orderPolicyHtml"></div>
              <div v-else>
                <div class="sp-extras">
                  <div class="sp-steps">
                    <div class="sp-steps-connector"></div>
                    <div class="sp-step">
                      <div class="sp-step-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          aria-hidden="true"
                          data-slot="icon"
                          class="sp-step-svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                          ></path>
                        </svg>
                      </div>
                      <div class="sp-step-info">
                        <p class="sp-step-date">Mar 20</p>
                        <p class="sp-step-label">Ordered</p>
                      </div>
                    </div>
                    <div class="sp-step">
                      <div class="sp-step-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          aria-hidden="true"
                          data-slot="icon"
                          class="sp-step-svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
                          ></path>
                        </svg>
                      </div>
                      <div class="sp-step-info">
                        <p class="sp-step-date">Mar 21 - Mar 30</p>
                        <p class="sp-step-label">Shipping</p>
                      </div>
                    </div>
                    <div class="sp-step">
                      <div class="sp-step-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          aria-hidden="true"
                          data-slot="icon"
                          class="sp-step-svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
                          ></path>
                        </svg>
                      </div>
                      <div class="sp-step-info">
                        <p class="sp-step-date">Mar 30 - Apr 04</p>
                        <p class="sp-step-label">Delivered</p>
                      </div>
                    </div>
                  </div>
                  <div class="sp-accordion">
                    <div class="sp-accordion-item">
                      <div class="sp-accordion-trigger">
                        <span class="sp-accordion-title">Shipping Rule</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          aria-hidden="true"
                          data-slot="icon"
                          class="sp-accordion-icon"
                        >
                          <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5"></path>
                        </svg>
                      </div>
                    </div>
                    <div class="sp-accordion-item">
                      <div class="sp-accordion-trigger">
                        <span class="sp-accordion-title">Return &amp; Refund</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          aria-hidden="true"
                          data-slot="icon"
                          class="sp-accordion-icon"
                        >
                          <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Description below product layout -->
        <div v-if="descriptionHtml" v-html="descriptionHtml"></div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { descriptionjs } from '../main';
import imageHelpers from '@/helpers/image';
import { replaceImageUrl } from '../common/utils';

const previewStyleState = {
  loaded: false,
  nodes: [],
};

export default {
  name: 'SectionPreview',
  props: {
    descriptionHtml: {
      type: String,
      default: '',
    },
    orderPolicyHtml: {
      type: String,
      default: '',
    },
    hurryBoxHtml: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    image: {
      type: [String, Object],
      default: null,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imageSrc() {
      if (!this.image) return '';
      if (typeof this.image === 'string') return this.image;
      if (typeof this.image === 'object' && typeof this.image.src === 'string') return this.image.src;
      return '';
    },
  },
  data() {
    return {
      previewMode: 'desktop',
      imageHelpers: imageHelpers,
      replaceImageUrl: replaceImageUrl,
    };
  },
  methods: {
    handleClose() {
      this.unloadPreviewStyle();
      this.$emit('close');
    },
    async loadPreviewStyle() {
      if (!previewStyleState.loaded) {
        const before = new Set(document.querySelectorAll('style, link[rel="stylesheet"]'));
        await import('../styles/section-preview-style.scss');
        const after = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'));
        previewStyleState.nodes = after.filter(node => !before.has(node));
        previewStyleState.loaded = true;
        return;
      }

      previewStyleState.nodes.forEach(node => {
        if (node && !node.parentNode) {
          document.head.appendChild(node);
        }
      });
    },
    unloadPreviewStyle() {
      previewStyleState.nodes.forEach(node => {
        if (node && node.parentNode) {
          node.parentNode.removeChild(node);
        }
      });
    },
  },
  beforeDestroy() {
    this.unloadPreviewStyle();
  },
  watch: {
    open: {
      async handler(isOpen) {
        if (!isOpen) {
          this.unloadPreviewStyle();
          return;
        }

        await this.loadPreviewStyle();

        this.$nextTick(() => {
          const container = this.$refs.sectionContainer;
          if (!container) return;

          const scriptsSwiper = container.querySelector('script[data-attribute="script-swiper"]');

          if (scriptsSwiper) {
            const newScriptCDN = document.createElement('script');
            newScriptCDN.src = scriptsSwiper.getAttribute('src');
            newScriptCDN.setAttribute('data-ignore', 'true');

            newScriptCDN.onload = () => {
              runOtherScripts();
            };

            scriptsSwiper.parentNode.replaceChild(newScriptCDN, scriptsSwiper);
          } else {
            runOtherScripts();
          }

          function runOtherScripts() {
            const scripts = container.querySelectorAll('script:not([data-executed]):not([data-ignore])');
            scripts.forEach(script => {
              const newScript = document.createElement('script');
              for (const attr of script.attributes) newScript.setAttribute(attr.name, attr.value);
              newScript.text = script.textContent;
              script.parentNode.replaceChild(newScript, script);
              newScript.setAttribute('data-executed', '1');
            });
          }
          descriptionjs();
        });
      },
      immediate: true,
    },
  },
};
</script>
<style scoped lang="scss">
.preview-section-header {
  position: sticky;
  top: 0;
  right: 0;
  left: 0;
  border-bottom: 1px solid #d1d5db;
  font-size: 20px;
  font-weight: 600;
  background-color: #ffffff;
  z-index: 200;
}

.policy-preview-image {
  width: 100%;
  height: 500px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }
}

.policy-preview-content-wrapper {
  display: flex;
  flex-direction: column;
}

.policy-preview-content {
  margin-bottom: 8px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.policy-preview-content-text {
  flex: 1;
}

// Section preview layout
.sp-layout {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 2rem;
  padding-top: 16px;
  padding-bottom: 0;

  @container (min-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    padding-top: 25px !important;
    padding-bottom: 25px !important;
  }
}

.sp-gallery {
  width: 100%;
  height: 500px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
  }
  @container (max-width: 768px) {
    height: 400px !important;
  }
}

.sp-info-col {
  position: relative;
}

.sp-info-wrapper {
  margin-bottom: 0.25rem;
  width: 100%;
}

.sp-reviewer-text {
  margin-bottom: 1rem;
}

.sp-title {
  margin-bottom: 0.75rem !important;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  line-clamp: 6;
  font-size: 1.5rem;
  line-height: 1.25 !important;
  color: #121212;
  font-weight: 700 !important;

  @container (min-width: 768px) {
    font-size: 2.25rem !important;
  }
}

.sp-rating {
  display: flex;
  align-items: center;
  width: fit-content;
  margin-bottom: 0.75rem;
}

.sp-stars {
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
  }
}

.sp-star-icon {
  width: 1.25rem;
  height: 1.25rem;
}

.sp-rating-count {
  margin-left: 0.5rem;
  font-size: 1rem;
  color: #6b7280;
  line-height: normal !important;
}

.sp-description {
  font-size: 0.875rem;

  @container (min-width: 768px) {
    font-size: 1rem !important;
  }
}

.sp-atc {
  margin-bottom: 0.75rem;
}

.sp-divider {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.sp-divider-line {
  height: 0.125rem;
  flex-grow: 1;
  background-color: #000;
}

.sp-divider-text {
  text-align: center;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  line-height: normal !important;
}

.sp-btn-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.sp-btn-cart {
  display: flex;
  height: 55px;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  background-color: var(--color-cart-background);
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: var(--color-cart-label);
  text-transform: uppercase;
  font-size: 1.125rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  border-radius: 6px;

  &:hover,
  &:focus,
  &:disabled {
    opacity: 0.8;
  }
}

.sp-btn-buynow {
  display: flex;
  height: 55px;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  background-color: var(--color-bynow-background);
  color: var(--color-bynow-label);
  text-transform: uppercase;
  font-size: 1.125rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  border-radius: 6px;

  &:hover,
  &:focus {
    opacity: 0.8;
  }
}

.sp-btn-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.sp-paypal {
  position: relative;
  z-index: 10;
  width: 100%;
  margin-top: 0.75rem;
  height: 62px;
}

.sp-paypal-inner {
  height: 3.5rem;
  width: 100%;
  background-color: #fec43a;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-weight: 700;
  font-size: 1.125rem;
  color: #000000;
  text-transform: uppercase;
  cursor: pointer;
  img {
    width: 70px;
    height: 100%;
    object-fit: contain;
  }
}

.sp-extras {
  margin-top: 1.5rem;

  & > * + * {
    margin-top: 1.5rem;
  }
}

.sp-steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  position: relative;
}

.sp-steps-connector {
  width: 70%;
  height: 0.125rem;
  background-color: #000;
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}

.sp-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.sp-step-icon {
  width: 2.75rem;
  height: 2.75rem;
  background-color: #000;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sp-step-svg {
  width: 1.5rem;
  height: 1.5rem;
  color: #fff;
}

.sp-step-info {
  text-align: center;
}

.sp-step-date {
  font-weight: 700;
  font-size: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  line-height: normal !important;

  @container (min-width: 768px) {
    font-size: 0.875rem !important;
  }
}

.sp-step-label {
  font-size: 0.75rem;
  line-height: normal !important;

  @container (min-width: 768px) {
    font-size: 0.875rem !important;
  }
}

.sp-accordion-item {
  border-bottom: 1px solid #e5e7eb;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;

  &:hover {
    background-color: #f3f4f6;
  }
}

.sp-accordion-trigger {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  text-align: left;
  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
  cursor: pointer;
  color: #121212;

  @container (min-width: 768px) {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }
}

.sp-accordion-title {
  font-size: 1rem;
  font-weight: 700;

  @container (min-width: 768px) {
    font-size: 1.125rem !important;
  }
}

.sp-accordion-icon {
  width: 1rem;
  height: 1rem;
  transition: transform 300ms ease;
}

/* Mobile preview: device frame so left/right safe area is obvious */
.mobile-preview {
  padding: 1.25rem 0.75rem 1.5rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 120px;
}

.mobile-preview .container-size.preview-wrapper {
  position: relative;
  width: 100%;
  max-width: 390px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 2.25rem;
  border: 0.65rem solid #1c1c1e;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06), 0 0.5rem 0 rgba(0, 0, 0, 0.35),
    0 1.25rem 2.5rem rgba(0, 0, 0, 0.35);
  background: #fff;
  overflow: hidden;
  /* Room below “dynamic island” + status bar */
  padding-top: 2.5rem;
  padding-bottom: 0.75rem;
}

.mobile-preview .container-size.preview-wrapper::before {
  content: '';
  position: absolute;
  top: 0.55rem;
  left: 50%;
  transform: translateX(-50%);
  width: 5.75rem;
  height: 1.5rem;
  background: #1c1c1e;
  border-radius: 999px;
  z-index: 5;
  pointer-events: none;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

/* Home indicator (like iPhone) — shows bottom safe margin */
.mobile-preview .container-size.preview-wrapper::after {
  content: '';
  display: block;
  width: 5.5rem;
  height: 0.3rem;
  margin: 0.75rem auto 0;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.35);
  flex-shrink: 0;
}
</style>
